import { make } from 'vuex-pathify';

const state = {
  isVisible: true,
};

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  mutations,
};
